import * as exBootstrap from '../../../bootstrap';

// ----------------------------------------------------------------------------

function hide(element: HTMLElement, config: Record<string, any> = {}): void {
    exBootstrap.hide('Dropdown', element, config);
}

// ----------------------------------------------------------------------------

export default hide;
